
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { Component, OnInit , ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { ViewApplicationDetailsComponent } from '../view-application-details/view-application-details.component';
import { DatePipe } from '@angular/common'
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake  from 'pdfmake/build/pdfmake.js';
// import pdfFonts from 'pdfmake/build/vfs_fonts.js';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-viewallrequest',
  templateUrl: './viewallrequest.component.html',
  styleUrls: ['./viewallrequest.component.scss']
})
export class ViewallrequestComponent implements OnInit {
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  loginform!: FormGroup;
  Requestform: any;
  role: any;
  loading = false;
  submitted = false;
  isShow!: boolean;
  paymentmsg: any;
  isChecked!: boolean;
  selectedstandard: any;
  photoinfo:boolean=true;
  allmigrationrequests: any;
  rowData:any;
  norecords: boolean=false;
  studData: any;
  marksinfo: any;
  showphoto:boolean=false;
  file_marksheet:any='';
  appid: any;
  tblvisible: boolean=false;
  physicalDoccheck:boolean=false;
  physicalDoccheckflag:boolean=false;
  recivedphysicalcopy!: boolean;
  noselectionmsg:any="Select Year to See List";
  studexamname: any;
  exam_month_year: any;
  standard: any;
  seat_no: any;
  varified_name_check: string="";
  varified_correct_name: string="";
  constructor(private service:UserserviceService ,public router: Router,private route: ActivatedRoute,private formBuilder: FormBuilder,public datepipe: DatePipe) { }
  public columnDefs: (ColDef | ColGroupDef)[] = [    
    {headerName: 'Application Id',field: 'application_id', width: 140, sortable: true, filter: true,sort: 'desc'  },
    {headerName: 'View',
          field: 'application_id',
          width: 90,
          cellRenderer:ViewApplicationDetailsComponent,
          cellRendererParams: {
          clicked: (field: any) => {
            this.getStudDetail(field);
          }
        },
    },
    {headerName: 'Standard',field: 'standard', width: 140, sortable: true, filter: true },
    {headerName: 'Seat No',field: 'seat_no', width: 120, sortable: true, filter: true },
    {headerName: 'Student Name',field:'stud_name', width: 240, sortable:true, filter:true},
    {headerName: 'School Index',field:'school_name', sortable: true, filter: true}, 
    {headerName: 'Acadamic Year',field: 'exam_month_year', sortable: true, filter: true },
    {headerName: 'Request Status',field:'request_status', sortable: true, filter: true},
    {headerName: 'Payment Status',field: 'payment_status',  sortable: true, filter: true},
    {headerName: 'Submitted On',field:'application_create_date', sortable:true,filter:true},
    {headerName: 'Application Status',field:'application_status', sortable:true,filter:true}
    // {headerName: 'View',field: 'View', sortable:true, filter: true,cellRenderer : function(params: any){
    //   return '<div><button class="btn btn-outline-primary btn-sm btnEdit"  data-bs-toggle="modal" href="#candidateprofile"><i  class="bi bi-eye-fill tblbtn"></button></div>'
    //    }
    // }
  ];
  
  public defaultColDef: ColDef = {
  // set the default column width
  width: 150,
  // make every column editable
  // editable: true,
  // make every column use 'text' filter by default
  filter: 'agTextColumnFilter',
  // enable floating filters by default
  
  // make columns resizable
  resizable: true,
  
  };
   
  
  ngOnInit(): void {
    if(!sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")==null){
      this.router.navigate(['/boardadminlogin']);
     // sessionStorage.clear();
    }
    else  if(sessionStorage.getItem('roleid')=="1"){
     this.router.navigate(['/dashboard']);
    }
    this.Requestform = this.formBuilder.group({
      stud_name:['',Validators.required],
      standard:['',Validators.required],
      mobile_no:['',[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],     
      email_address:['',[Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      address:['',Validators.required],
      pincode:['',Validators.required],
      exam_month_year:['',Validators.required],
      certificate_delivery_mode:['',Validators.required],
      seat_no:['',Validators.required],
      school_name:['',Validators.required],
      application_type:['',Validators.required],
      upload_photo:['',Validators.required],
      physicalcheck:new FormControl(''),
      payment_status:['',Validators.required],
      upload_marksheet:['',Validators.required],
  
    });
  
  // this.getallmigrationrequest();
  this.getallrequest();
  }
   
    onBtExport() {
      this.agGrid.api.exportDataAsCsv();
    }
    
  
  get f() { return this.Requestform.controls; }
  
  onSubmit(form:any ){
    this.submitted = true;
    if (this.Requestform.invalid) {
      alert("Please Fill All Details!");
      // this.findInvalidControls();
      return;
    }
    else{
    //  alert("form is valid");
      this.updatestuddetails();
    } 

  } 
//   findInvalidControls() {
//     const invalid = [];
//     const controls = this.Requestform.controls;
//     for (const name in controls) {
//         if (controls[name].invalid) {
//             invalid.push(name);
//         }
//     }
//     console.log(invalid);
// }
  // getallmigrationrequest(){
  //   let app_type:{application_type:any}={
  //     application_type: "Fresh_Migration_Certificate"
  //   }
  //   this.service.post('/Boardadmin_module/fetch_all_student_applied_applicationwise',app_type).subscribe((res:any)=>{
  //     if(res.status=="success"){
  //         this.allmigrationrequests=res.Data;
  //         this.rowData=[this.allmigrationrequests[0]];
  //         console.log(this.rowData);
  //     }
  //     else{

  //     }
      
  //   });

  // }
//get year wise application requests
  getallrequest(){
       
              this.service.post('/Boardadmin_module/fetch_student_applied_all_migration',{}).subscribe((res:any)=>{
                // console.log(res);
                if(res.status=="success"){
                  this.allmigrationrequests=res.Data;
                  this.rowData=[this.allmigrationrequests];
                  this.tblvisible=true;
                  // console.log(this.rowData);           
                }
                else{
                  this.tblvisible=false;
                  this.noselectionmsg="No Requests Submitted Yet!"
                }                  
            });
      //  }  
      //  else{
      //     this.tblvisible=false;
      //  }
  }
  // getallrequestyearwise(selectyear:any){
  //      if(selectyear.value!=""){
  //           this.tblvisible=true;
  //           let getstud: { selectedyear:any}={
  //             selectedyear: selectyear.value
  //           };
  //             this.service.post('/Boardadmin_module/fetch_student_applied_yearwise_migration',getstud).subscribe((res:any)=>{
  //               // console.log(res);
  //               if(res.status=="success"){
  //                 this.allmigrationrequests=res.Data;
  //                 this.rowData=[this.allmigrationrequests];
  //                 // console.log(this.rowData);           
  //               }
  //               else{
  //                 this.tblvisible=false;
  //                 this.noselectionmsg="No Requests Submitted Yet!"
  //               }                  
  //           });
  //      }  
  //      else{
  //         this.tblvisible=false;
  //      }
  // }
  //get single student
  getStudDetail(app_id:any){
    this.appid=app_id;
    let getstud:{ app_id:any}={
      app_id: this.appid
    };
      this.service.post('/Boardadmin_module/fetch_application_details_by_appid',getstud).subscribe((res:any)=>{
        if(res.status=="success"){
              this.studData=res.Data[0];
            
            if(this.studData){
              // this.Requestform.controls['saluation'].setValue(this.studData.saluation);
              this.Requestform.controls['stud_name'].setValue(this.studData.stud_name);
              this.Requestform.controls['standard'].setValue(this.studData.standard);
              this.Requestform.controls['mobile_no'].setValue(this.studData.mobile_no);
              this.Requestform.controls['application_type'].setValue(this.studData.application_type.replace(/_+/g," "));
              this.Requestform.controls['email_address'].setValue(this.studData.email_address);
              this.Requestform.controls['address'].setValue(this.studData.address);
              this.Requestform.controls['pincode'].setValue(this.studData.pincode);             
              this.Requestform.controls['exam_month_year'].setValue(this.studData.exam_month_year);
              this.Requestform.controls['certificate_delivery_mode'].setValue(this.studData.certificate_delivery_mode.replace(/_+/g," "));
              this.Requestform.controls['seat_no'].setValue(this.studData.seat_no);
              this.Requestform.controls['school_name'].setValue(this.studData.school_name);
              this.Requestform.controls['payment_status'].setValue(this.studData.payment_status);
              this.Requestform.controls['physicalcheck'].setValue(this.studData.physical_copy_checked);
              if(this.studData.verified_name=="Varified" || this.studData.verified_name==""){
                this.varified_name_check="verified";
              }
              else{
                this.varified_name_check="Name is not as per school data"
                this.varified_correct_name=this.studData.original_first_name;
               }
              // this.Requestform.patchValue({
              //   physicalcheck:this.studData.physical_copy_checked
              // }); 
             this.physicalDoccheck=this.studData.physical_copy_checked;
              if(!(this.studData.upload_photo=="" || this.studData.upload_photo== null || this.studData.upload_photo==undefined)){
                this.photoinfo=this.studData.upload_photo; 
                this.Requestform.controls['upload_photo'].clearValidators();
                this.Requestform.controls['upload_photo'].updateValueAndValidity();
              }
              if(!(this.studData.upload_marksheet=="" || this.studData.upload_marksheet== null || this.studData.upload_marksheet==undefined)){
                this.marksinfo=this.studData.upload_marksheet;
                this.Requestform.controls['upload_marksheet'].clearValidators();
                this.Requestform.controls['upload_marksheet'].updateValueAndValidity();
              }   
              this.exam_month_year=this.studData.exam_month_year;
              this.standard=this.studData.standard;
              this.seat_no=this.studData.seat_no;       
            } 
       
      }
        else{
          this.studData="";
          alert("Page is having problem in loading, Please retry!")
          this.router.navigate(['/dashboard']);
        }
          
      });
    //get student deatils in studData variable
    
}
openmodal(mdl:any){
  let testmodal=document.getElementById(mdl);
  testmodal?.style.setProperty("display","block");
}
closemodal(mdl:any){
  let testmodal=document.getElementById(mdl);
  testmodal?.style.setProperty("display","none");
}
getmarksheet(event:any){
  const fileList: FileList = event.target.files;
  //check whether file is selected or not
if (fileList.length > 0) {
    const file = fileList[0];
     if((file.size/1048576)<=4)
    {
      let formData = new FormData();
      let info={id:2,name:'raja'}
      formData.append('marksheetfile', file, file.name);
      this.file_marksheet=event.target.files[0];
      // this.marksinfo=event.target.files[0]; 
    }   
  }  
  
}
updatestuddetails(){  
  if(this.Requestform.value.physicalcheck!="Received"){
    this.recivedphysicalcopy = confirm("Physical Copy Of Documents Not Received! \n \n Are you sure you want to proceed with information updation?");
  }
  if(this.recivedphysicalcopy || this.Requestform.value.physicalcheck=="Received"){
          let conf=confirm("Are you sure to change Deatils for this application Id:"+this.appid+" ??");
          if(conf==true){
            let studdetail = new FormData;
              studdetail.append('application_id',this.appid); 
              studdetail.append('stud_name',this.Requestform.value.stud_name); 
              studdetail.append('address',this.Requestform.value.address);
              studdetail.append('pincode',this.Requestform.value.pincode);
              studdetail.append('physical_copy_checked',this.Requestform.value.physicalcheck);
              studdetail.append('payment_status',this.Requestform.value.payment_status);
              studdetail.append('application_type',this.Requestform.value.application_type.replace(/ +/g,"_"));
          
            if(this.file_marksheet!=""){
              studdetail.append('upload_marksheet',this.file_marksheet,this.file_marksheet.name);
            }   
              this.service.post('/Boardadmin_module/update_application_details_by_appid',studdetail).subscribe((res:any)=>{
                // console.log(res);
                if(res.status=="success"){
                    alert(res.Data+"\r\n ");              
                    this.router.navigate(['/viewapplicationstatus'])
                    window.location.reload();    
                }
                else{
                  alert(res.Data);
                }
            });
          }//confirm end
    }     
 }

  generateCertificate(){
      let c=confirm("Are you sure to generate "+this.Requestform.value.application_type.replace(/_+/g," ")+" for Application No: "+this.appid+"?")
      if(c==true){
        this.generateapplicationPdf();
      }
  }

  generateapplicationPdf(){
    // alert("Pdf Download");
    if(this.studData.standard=="HSSC"){
          this.studexamname="Higher Secondary";
    }
    else if(this.studData.standard=="SSC"){
          this.studexamname="Secondary";          
    }
    const documentDefinition = { 
      info: {
        title: 'Migration Certificate of '+ this.studData.stud_name+'-'+this.appid,
        author: 'GBSHSE',
        subject:'Migration Certificate of '+ this.studData.stud_name+'-'+this.appid
        },
      footer: {
        margin: [5, 0, 0, 10],
        columns: [
          {  text: 'Date: '+this.datepipe.transform(new Date(), 'dd-MM-yyyy'), 
             alignment: 'left' ,
             
          }
        ]
      },
      content: [
        {
          text: 'Goa Board of Secondary and.Higher Secondary Education,',
          bold: true,
          fontSize: 18,
          alignment: 'center',
          margin: [0, 0, 0, 10]
        },
        {
          text: '(A Corporate Statutory Body Constituted by an Act of the State Legislature)',
          // bold: true,
          fontSize: 13,
          alignment: 'center',
          margin: [0, 0, 0, 7]
        },
        {
          text: 'Alto - Betim, Goa 403521',
          // bold: true,
          fontSize: 13,
          alignment: 'center',
          margin: [0, 0, 0, 7]
        },
        {
          text: 'Website: www.gbshse.gov.in                                              '+' email: sss-gbshse.goa@nir.in                                  ' + 'ph: (0832) 2417553' ,
           // bold: true,
          fontSize: 9,
          // alignment: 'center',
          margin: [0, 0, 0, 7]
        },
        {
          text: '..................................................................................................................................................................................................................' ,
           // bold: true,
          fontSize: 9,
          // alignment: 'center',
          margin: [0, 0, 0, 7]
        },
        {
          text: '\u200B\t\t\tThis is to certify that '+ this.studData.stud_name.toUpperCase()+', Examination Seat No. '+this.studData.seat_no+'   has passed the '+ this.studexamname+' School Certificate Examination held by this Board in '+this.studData.exam_month_year+ '.',
           // bold: true,
          fontSize: 14,
          // alignment: 'center',
          lineHeight:2,
          margin: [5, 25, 5, 10]
        },
        {
          text: '\u200B\t\t\tThere is no objection to the candidate\'s joining an institution recognised by the Board or affiliated to a University.' ,
           // bold: true,
          fontSize: 14,
          // alignment: 'center',
          lineHeight:2,
          margin: [5, 15, 5, 10]
        },        
      ]
    };
    // (pdfMake as any).createPdf(documentDefinition).open();
    // (pdfMake as any).createPdf(documentDefinition).download('Migration Certificate of '+ this.studData.stud_name+'.pdf');
    (pdfMake as any).createPdf(documentDefinition).open({defaultFileName:'Migration Certificate of '+ this.studData.stud_name+'.pdf'});
   }
   
   direct_reject_request(){
     let c=confirm("Are you sure you want to Reject this application??");
     if(c==true){
        let direct_reject_app_id:{app_id:any}={
          app_id:this.appid
        }

        this.service.post('/Boardadmin_module/reject_application_by_appid',direct_reject_app_id).subscribe((res:any)=>{
          // console.log(res);
          if(res.status=="success"){
              alert(res.Data+"\r\n ");   
              window.location.reload();             
          }
          else{
            alert(res.Data);
          }
       });
        
     } 
   }

}
  